import { render, staticRenderFns } from "./AddFeature.vue?vue&type=template&id=bb440a1e&scoped=true&"
import script from "./AddFeature.vue?vue&type=script&lang=js&"
export * from "./AddFeature.vue?vue&type=script&lang=js&"
import style0 from "./AddFeature.vue?vue&type=style&index=0&id=bb440a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb440a1e",
  null
  
)

export default component.exports